<template>
  <InformationDossierStep />
  <SyntheseReglementsStep v-if="estDemandeDR" />
  <MissionStep v-if="estMissionVisible" />
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status'
  import { storeToRefs } from 'pinia'
  import { computed, inject } from 'vue'
  import { DEMANDE_STORE } from '../../../shared'
  import InformationDossierStep from './sections/informationDossier/InformationDossierStep.vue'
  import SyntheseReglementsStep from './sections/reglements/SyntheseReglementsStep.vue'
  import MissionStep from './sections/mission/MissionStep.vue'
  import { DR_ACTIONS } from '@/features/interface/demande/dr/useDRActions.ts'

  const store = inject(DEMANDE_STORE)!.getStore<'MODEL_DR'>()
  const { meta } = storeToRefs(store)

  const { estDemandeDR } = inject(DR_ACTIONS)!
  const estMissionVisible = computed(() => {
    if (!estDemandeDR.value) return false
    return meta.value.mission?.$status !== PropertyStatus.NotPresent
  })
</script>
